// import moment from 'moment'
export default [
    {
        text: '#',
        sortable: false,
        value: 'id',
    },
    {
        text: 'Nombre',
        sortable: false,
        value: 'name',
    },
]
